import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useRef } from 'react';
import { useKeyboardNavigation } from '../search-keyboard';

/**
 * Callback which simulates a click on the target element when the enter key
 * is pressed whilst the target element is active.
 *
 * @param e Event from key down
 * @param target Active element when key was pressed
 */
var onKeyDown = function onKeyDown(e, target) {
  // Only navigate if Enter was pressed without any modifiers
  if (e.key === 'Enter' && !e.shiftKey && !e.metaKey && !e.ctrlKey) {
    e.preventDefault();

    // Find the deepest child element in the DOM
    var clickTarget = target;
    while (clickTarget.firstElementChild instanceof HTMLElement && (_clickTarget$firstEle = clickTarget.firstElementChild) !== null && _clickTarget$firstEle !== void 0 && _clickTarget$firstEle.click) {
      var _clickTarget$firstEle;
      clickTarget = clickTarget.firstElementChild;
    }
    clickTarget.click();
  }
};
export var useKeyboardHighlighting = function useKeyboardHighlighting(_ref) {
  var searchResultId = _ref.searchResultId,
    onHighlighted = _ref.onHighlighted;
  var _useKeyboardNavigatio = useKeyboardNavigation({
      onKeydownCallback: onKeyDown,
      navigationTrackingId: searchResultId !== null && searchResultId !== void 0 ? searchResultId : null
    }),
    _useKeyboardNavigatio2 = _slicedToArray(_useKeyboardNavigatio, 2),
    isKeyboardHighlighted = _useKeyboardNavigatio2[0],
    ref = _useKeyboardNavigatio2[1];

  // Ref for whether or not this search result was last highlighted
  var previousHighlight = useRef(false);

  // Call the onHighlighted callback when this search result is highlighted
  useEffect(function () {
    if (!previousHighlight.current && isKeyboardHighlighted) {
      onHighlighted === null || onHighlighted === void 0 || onHighlighted();
    }
    previousHighlight.current = isKeyboardHighlighted;
  }, [isKeyboardHighlighted, previousHighlight, onHighlighted]);
  return {
    isKeyboardHighlighted: isKeyboardHighlighted,
    ref: ref
  };
};